export default {
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    transactions() {
      return this.$store.state.userTransactions;
    },
    status_transactions() {
      return this.$store.state.userStatusTransactions;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    getTypeLabel(type) {
      return type === 'in' ? { label: 'Начислено', color: 'green' } : { label: 'Потрачено', color: 'red' };
    },
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetTransactions');
    this.$store.dispatch('GetStatusTransactions');
    this.$store.dispatch('SetTitle', 'Транзакции');
    const { type } = this.$route.params;
    if (type) {
      if (type === 'points') {
        this.tab = 0;
      } else if (type === 'status_points') {
        this.tab = 1;
      }
    }
  },
};
